const meir = {
    mail:`benhamomeir@gmail.com`
}
const yossi = {
    mail:`yossi52p@gmail.com`
}
export const contact ={
    address:'כתובת',
    owners:'בעלים',
    mail:'מייל',
    phone: 'טלפון מוקד מכירות'
}

export const contact_val = {
    address:'סמילנסקי 26, באר שבע',
    owners:'יוסי איטח ומאיר בן חמו',
    mail:`מאיר - ${meir.mail}, יוסי - ${yossi.mail}`,
    phone:`073-3963555`
}

export const email_contact={
    fullName: 'שם מלא',
    email: 'מייל',
    project: 'פרויקט',
    phone:'טלפון',
}

export const header = `צור קשר`;
